<template>
  <div class="home">
    <router-link to="/works?type=collections">
      <div
        v-if="selectedCollectionIndex == null"
        class="btn fixed bottom-[3vh] rtl:left-[3vw] ltr:right-[3vw] z-[1] text-center lg:bottom-8 transition-all duration-700 cursor-pointer min-w-[120px]"
      >
        <div class="flex items-center absolute bottom-0 cursor-pointer group">
          <div class="text-base px-4 text-white">{{ content.infinity }}</div>
          <div class="h-8 w-8 bg-white rounded-full flex items-center justify-center">
            <i
              class="fa fa-arrow-down ltr:-rotate-90 rotate-90 text-lg ltr:group-hover:ml-1 rtl:group-hover:mr-1 transition-all duration-200"
            ></i>
          </div>
        </div>
      </div>
    </router-link>
    <div
      class="bg-white top-[50vh] h-[50vh] fixed lg:top-0 text-section-home flex flex-col px-[3vw]"
      id="home-text-section"
      :class="showMoreText ? 'justify-start py-10' : 'justify-center py-0 '"
    >
      <div
        class="flex items-center mb-4 cursor-pointer"
        @click="toSlide(null)"
        v-if="!showMoreText"
      >
        <i class="fa fa-arrow-left rtl:rotate-180"></i>
        <div class="ltr:ml-2 rtl:mr-2">{{ content.back }}</div>
      </div>
      <div class="text-2xl leading-9 mb-4">
        {{ home?.data[selectedCollectionIndex]?.title }}
      </div>
      <div
        class="overflow-hidden lg:max-h-full transition-all duration-500"
        :class="showMoreText ? 'max-h-[500px] ' : 'ltr:max-h-[100px] rtl:max-h-[110px]'"
      >
        <div
          class="lg:w-10/12 w-full rtl:leading-7"
          v-html="home?.data[selectedCollectionIndex]?.description"
        ></div>
      </div>
      <div @click="showMoreText = !showMoreText" class="font-bold mt-3 flex lg:hidden">
        {{ !showMoreText ? content.showMore : content.showLess }}
      </div>

      <router-link
        :to="home?.data[selectedCollectionIndex]?.link"
        v-if="home?.data[selectedCollectionIndex]?.link"
      >
        <div
          class="py-4 px-10 bg-primary text-center mt-5 w-max transition-all duration-700 hover:bg-secondary cursor-pointer min-w-[180px]"
        >
          {{ content.view }}
        </div>
      </router-link>
    </div>
    <div
      class="fixed ltr:left-[3vw] rtl:right-[3vw] text-white z-[2] h-[100vh] flex flex-col justify-center collections-years"
    >
      <div
        class="font-lg mb-5 cursor-pointer"
        @click="toSlide(index)"
        v-for="(section, index) in home?.data"
        :key="section?.id"
      >
        {{ section.subtitle }}
      </div>
    </div>

    <div class="absolute w-full" :style="`height:${innerHeight}px`">
      <div class="imgscope ltr">
        <div class="imgscope_wrapper">
          <div
            class="md:w-[220px] w-[150px] h-auto md:m-[50px] m-[30px] overflow-hidden relative bg-[#fff0]"
            v-for="img in 135"
            :key="img"
            :class="`work-bg-${img}`"
          >
            <div
              class="md:w-[220px] w-[150px] h-full bg-image-fade flex justify-center items-center"
              :class="`bg-image-fade-${img}`"
            ></div>

            <img
              :id="`img_${img}`"
              :src="`https://s3.eu-central-1.amazonaws.com/images.ismailkhayat.com/home_images/${
                img > 45 && img <= 90 ? img - 45 : img > 90 ? img - 90 : img
              }.webp`"
              alt="work"
              class="w-max h-max relative work-img-home"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export default {
  inject: ["content"],
  data() {
    return {
      showMoreText: false,
      selectedCollection: null,
      randomMovingTimeline: null,
      backToStartTimeline: null,
      showContent: false,
      isMoving: false,
      lastItem: null,
      lastWorkBg: null,
      // 1 , 11 , 14 , 16 , 25
      allCollections: [24, 53, 75, 99, 41],
      selectedCollectionIndex: null,
      currentPosition: {
        left: 0,
        top: 0,
      },
    };
  },
  computed: {
    screenSize() {
      return window.innerWidth;
    },
    screenHeight() {
      return window.innerHeight;
    },

    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    home() {
      return this.$store.getters["home/home"];
    },
    direction() {
      let language = localStorage.getItem("lang");
      let direction;
      if (language == "ku") {
        direction = "rtl";
      } else if (language == "en") {
        direction = "ltr";
      }
      return direction;
    },
  },
  methods: {
    backToStart() {
      let tl = gsap.timeline();
      tl.set(".imgscope_wrapper", {
        translateX: this.currentPosition.left,
        translateY: this.currentPosition.top,
      });
      tl.to(".imgscope_wrapper", {
        translateX: -window.innerWidth / 10,
        translateY: -window.innerHeight / 10,
        duration: 8,
      });
      this.backToStartTimeline = tl;
    },
    toSlide(index) {
      if (this.isMoving) return;
      this.selectedCollectionIndex = index;
    },

    randomMoving() {
      // animating work images wrapper to random positions
      let tl = gsap.timeline({ repeat: -1 });
      tl.set(".imgscope_wrapper", {
        translateX: -window.innerWidth / 10,
        translateY: -window.innerHeight / 10,
        duration: 10,
      });
      tl.to(".imgscope_wrapper", {
        translateX: -(window.innerWidth - window.innerWidth / 10),
        translateY: -(window.innerHeight - window.innerHeight / 10),
        duration: 10,
      });
      tl.to(".imgscope_wrapper", {
        translateX: -window.innerWidth,
        translateY: -window.innerHeight / 7,
        duration: 6,
      });
      tl.to(".imgscope_wrapper", {
        translateX: -10,
        translateY: -window.innerHeight,
        duration: 10,
      });
      tl.to(".imgscope_wrapper", {
        translateX: -window.innerWidth / 10,
        translateY: -window.innerHeight / 10,
        duration: 6,
      });
      this.randomMovingTimeline = tl;
    },
    selectCollection() {
      // handling multiple scroll events
      if (this.isMoving) return;
      this.isMoving = true;
      this.selectedCollection = this.allCollections[this.selectedCollectionIndex];
      let selectedItem = document.getElementById(`img_${this.selectedCollection}`);
      // getting selected item  parent element
      let itemParent = selectedItem.parentElement;
      // getting left of selected item
      let itemLeft =
        selectedItem.getBoundingClientRect().left - this.currentPosition.left;
      // getting top of selected item
      let ItemTop = selectedItem.getBoundingClientRect().top - this.currentPosition.top;
      // calculating left and top of selected item
      let toLeft = (window.innerWidth - selectedItem.clientWidth) / 2 - itemLeft;
      let toTop = (window.innerHeight - selectedItem.clientHeight) / 2 - ItemTop;
      // animating selected item to center and right of the screen
      let tl2 = gsap.timeline();
      // checking if selected item is not the last item
      if (this.lastItem != `img_${this.selectedCollection}`) {
        // removing last item
        if (this.lastItem != null && this.screenSize > 1024) {
          if (this.direction == "ltr") {
            tl2.to(
              ".text-section-home",
              { left: "-51vw", opacity: 1, duration: 1, zIndex: 1 },
              "remove"
            );
          } else if (this.direction == "rtl") {
            tl2.to(
              ".text-section-home",
              { right: "-51vw", opacity: 1, duration: 1, zIndex: 1 },
              "remove"
            );
          }

          tl2.to(
            `#${this.lastItem}`,
            { translateX: 0, opacity: 0.8, duration: 1, zIndex: 0 },
            "remove"
          );
          tl2.to(`.${this.lastWorkBg}`, { translateX: 0, duration: 1 }, "remove");
          tl2.to(`#${this.lastItem}`, { scaleX: 1, scaleY: 1, duration: 1 }, "remove");
          tl2.to(
            `.${this.lastWorkBg}`,
            {
              scaleX: 1,
              scaleY: 1,
              zIndex: 0,
              backgroundColor: "#fff0",
              duration: 1,
            },
            "remove"
          );
          tl2.to(itemParent, { overflow: "hidden", duration: 0.05 }, "remove");
        } else if (this.lastItem != null && this.screenSize < 1024) {
          tl2.to(
            ".text-section-home",
            { top: "100vh", opacity: 1, duration: 1, zIndex: 1 },
            "remove"
          );
          tl2.to(
            `#${this.lastItem}`,
            { translateX: 0, opacity: 0.8, duration: 1, zIndex: 0 },
            "remove"
          );
          tl2.to(`.${this.lastWorkBg}`, { translateY: 0, duration: 1 }, "remove");
          tl2.to(`#${this.lastItem}`, { scaleX: 1, scaleY: 1, duration: 1 }, "remove");
          tl2.to(
            `.${this.lastWorkBg}`,
            {
              scaleX: 1,
              scaleY: 1,
              zIndex: 0,
              backgroundColor: "#fff0",
              duration: 1,
            },
            "remove"
          );
          tl2.to(itemParent, { overflow: "hidden", duration: 0.05 }, "remove");
        }
      }
      // animating selected item to center of the screen
      tl2.to(
        ".imgscope_wrapper",
        { translateX: toLeft, translateY: toTop, duration: 3 },
        "start"
      );
      tl2.to(
        `.work-bg-${this.selectedCollection}`,
        {
          zIndex: 1,
        },
        "start"
      );
      tl2.to(itemParent, { overflow: "unset", duration: 0.05 }, "mid");
      if (this.screenSize > 1024) {
        // scaling selected item to 50% of viewport size
        tl2.to(
          `#img_${this.selectedCollection}`,
          {
            scaleX: (1 / (window.innerWidth / selectedItem.clientWidth / 2)) * 1.7,
            scaleY: (1 / (window.innerHeight / selectedItem.clientHeight)) * 1.7,
            duration: 1,
          },
          "end"
        );
        tl2.to(
          `.header`,
          {
            opacity: 0,
            zIndex: -1,
            duration: 1,
          },
          "end"
        );

        tl2.to(
          `.work-bg-${this.selectedCollection}`,
          {
            scaleX: window.innerWidth / selectedItem.clientWidth / 2,
            scaleY: window.innerHeight / selectedItem.clientHeight,
            duration: 1,
          },
          "end"
        );
        tl2.to(
          `.bg-image-fade-${this.selectedCollection}`,
          {
            zIndex: 1,
            opacity: 0.2,
            duration: 1,
          },
          "end"
        );
        //hiding years section
        tl2.to(`.collections-years`, { zIndex: 0 }, "end");
        //showing text section
        if (this.direction == "ltr") {
          tl2.to(
            ".text-section-home",
            { left: 0, opacity: 1, duration: 1, zIndex: 1 },
            "end2-=1"
          );
        } else if (this.direction == "rtl") {
          tl2.to(
            ".text-section-home",
            { right: 0, opacity: 1, duration: 1, zIndex: 1 },
            "end2-=1"
          );
        }
        // increasing opacity of selected item
        tl2.to(
          `#img_${this.selectedCollection}`,
          { opacity: 1, duration: 1, zIndex: 2 },
          "end2-=1"
        );
        // translating background of selected item to right of the screen
        if (this.direction == "ltr") {
          tl2.to(
            `.work-bg-${this.selectedCollection}`,
            {
              backgroundColor: "#fff",
              translateX: window.innerWidth / 4,
              opacity: 1,
              duration: 1,
              zIndex: 1,
            },
            "end2-=1"
          );
        } else if (this.direction == "rtl") {
          tl2.to(
            `.work-bg-${this.selectedCollection}`,
            {
              backgroundColor: "#fff",
              translateX: -window.innerWidth / 4,
              opacity: 1,
              duration: 1,
              zIndex: 1,
            },
            "end2-=1"
          );
        }

        // setting current position of  the last item
        this.currentPosition = { left: toLeft, top: toTop };
        this.lastItem = `img_${this.selectedCollection}`;
        this.lastWorkBg = `work-bg-${this.selectedCollection}`;
      } else {
        // scaling selected item to 50% of viewport size
        if (selectedItem.clientHeight > 190) {
          tl2.to(
            `#img_${this.selectedCollection}`,
            {
              scaleX: (1 / (window.innerWidth / selectedItem.clientWidth)) * 1.5,
              scaleY: (1 / (window.innerHeight / selectedItem.clientHeight / 2)) * 1.5,
              duration: 1,
            },
            "end"
          );
        } else {
          tl2.to(
            `#img_${this.selectedCollection}`,
            {
              scaleX: (1 / (window.innerWidth / selectedItem.clientWidth)) * 2,
              scaleY: (1 / (window.innerHeight / selectedItem.clientHeight / 1.55)) * 2,
              duration: 1,
            },
            "end"
          );
        }
        tl2.to(
          `.header`,
          {
            zIndex: -1,
            opacity: 0,
            duration: 1,
          },
          "end"
        );
        tl2.to(
          `.work-bg-${this.selectedCollection}`,
          {
            scaleX: window.innerWidth / selectedItem.clientWidth + 0.1,
            scaleY: window.innerHeight / selectedItem.clientHeight / 1.55,
            duration: 1,
          },
          "end"
        );
        tl2.to(
          `.bg-image-fade-${this.selectedCollection}`,
          {
            zIndex: 1,
            opacity: 0.2,
            duration: 1,
          },
          "end"
        );
        //hiding years section
        tl2.to(`.collections-years`, { zIndex: 0 }, "end");
        //showing text section
        tl2.to(
          ".text-section-home",
          { top: "50vh", opacity: 1, duration: 1, zIndex: 1 },
          "end2-=1"
        );

        // increasing opacity of selected item
        tl2.to(
          `#img_${this.selectedCollection}`,
          { opacity: 1, duration: 1, zIndex: 2 },
          "end2-=1"
        );
        // translating background of selected item to right of the screen
        tl2.to(
          `.work-bg-${this.selectedCollection}`,
          {
            backgroundColor: "#fff",
            translateY: -(window.innerHeight / 4) - 3,
            opacity: 1,
            duration: 1,
            zIndex: 1,
          },
          "end2-=1"
        );

        // setting current position of  the last item
        this.currentPosition = { left: toLeft, top: toTop };
        this.lastItem = `img_${this.selectedCollection}`;
        this.lastWorkBg = `work-bg-${this.selectedCollection}`;
      }
      // setting isMoving to false after animation is finished
      setTimeout(() => {
        this.isMoving = false;
      }, 5000);
    },
    setNewPosition(wrapper) {
      let replaceWrapper = wrapper.style.transform
        .replace("translate3d(", "")
        .replace(")", "")
        .replace(/px/g, "");
      // creating array of current position
      let values = replaceWrapper.split(",");
      // setting current position to data
      this.currentPosition.left = parseInt(values[0]);
      this.currentPosition.top = parseInt(values[1]);
    },
  },
  watch: {
    selectedCollectionIndex() {
      if (this.isMoving) return;
      if (
        this.isSafari &&
        this.selectedCollectionIndex != null &&
        this.screenSize < 1024
      ) {
        document.body.style.overflow = "hidden";
      }
      if (
        this.isSafari &&
        !this.selectedCollectionIndex != null &&
        this.screenSize < 1024
      ) {
        document.body.style.overflow = "unset";
      }
      let wrapper = document.querySelector(".imgscope_wrapper");
      if (this.selectedCollectionIndex != null) {
        if (this.backToStartTimeline.isActive()) {
          this.backToStartTimeline.pause();
          // getting current position of work images wrapper from styles
          this.setNewPosition(wrapper);
        }
        if (this.randomMovingTimeline.isActive()) {
          this.randomMovingTimeline.pause();
          // getting current position of work images wrapper from styles
          this.setNewPosition(wrapper);
        }
        this.selectCollection();
      } else if (this.selectedCollectionIndex == null) {
        let tl2 = gsap.timeline();
        if (this.lastItem != null && this.screenSize > 1024) {
          if (this.direction == "ltr") {
            tl2.to(
              ".text-section-home",
              { left: "-51vw", opacity: 1, duration: 1, zIndex: 1 },
              "remove"
            );
          } else if (this.direction == "rtl") {
            tl2.to(
              ".text-section-home",
              { right: "-51vw", opacity: 1, duration: 1, zIndex: 1 },
              "remove"
            );
          }
          tl2.to(
            `.header`,
            {
              zIndex: 1,
              opacity: 1,
              duration: 1,
            },
            "remove"
          );
          tl2.to(
            `#${this.lastItem}`,
            { translateX: 0, opacity: 0.8, duration: 1, zIndex: 0 },
            "remove"
          );
          tl2.to(`.${this.lastWorkBg}`, { translateX: 0, duration: 1 }, "remove");
          tl2.to(`#${this.lastItem}`, { scaleX: 1, scaleY: 1, duration: 1 }, "remove");
          tl2.to(
            `.bg-image-fade-${this.selectedCollection}`,
            {
              zIndex: -1,
              opacity: 0,
              duration: 1,
            },
            "remove"
          );
          tl2.to(
            `.${this.lastWorkBg}`,
            {
              backgroundColor: "#fff0",
              scaleX: 1,
              scaleY: 1,
              zIndex: 0,
              duration: 1,
            },
            "remove"
          );
          tl2.to(`.collections-years`, { zIndex: 2 }, "remove");
        }
        if (this.lastItem != null && this.screenSize < 1024) {
          tl2.to(
            ".text-section-home",
            { top: "101vh", opacity: 1, duration: 1, zIndex: 1 },
            "remove"
          );
          tl2.to(
            `.header`,
            {
              zIndex: 1,
              opacity: 1,
              duration: 1,
            },
            "remove"
          );
          tl2.to(
            `#${this.lastItem}`,
            { translateX: 0, opacity: 0.8, duration: 1, zIndex: 0 },
            "remove"
          );
          tl2.to(`.${this.lastWorkBg}`, { translateY: 0, duration: 1 }, "remove");
          tl2.to(`#${this.lastItem}`, { scaleX: 1, scaleY: 1, duration: 1 }, "remove");
          tl2.to(
            `.bg-image-fade-${this.selectedCollection}`,
            {
              zIndex: -1,
              opacity: 0,
              duration: 1,
            },
            "remove"
          );
          tl2.to(
            `.${this.lastWorkBg}`,
            {
              backgroundColor: "#fff0",
              scaleX: 1,
              scaleY: 1,
              zIndex: 0,
              duration: 1,
            },
            "remove"
          );
          tl2.to(`.collections-years`, { zIndex: 2 }, "remove");
        }
        this.backToStart();

        setTimeout(() => {
          if (this.selectedCollectionIndex == null) {
            this.randomMovingTimeline.restart();
          }
        }, 8500);
      }
    },
    showMoreText() {
      let textSection = document.getElementById("home-text-section");
      if (this.screenSize <= 1024) {
        if (this.showMoreText) {
          textSection.style.height = "100vh";
          textSection.style.top = "0";
        } else {
          textSection.style.height = "50vh";
          textSection.style.top = "50vh";
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      let tl = gsap.timeline();
      tl.set(".imgscope_wrapper", {
        translateX: -window.innerWidth / 10,
        translateY: -window.innerHeight / 10,
      });
      this.backToStartTimeline = tl;
      this.randomMoving();
      let footer = document.getElementById("footer");
      footer.style.display = "none";
    }, 2);
  },
  unmounted() {
    let footer = document.getElementById("footer");
    footer.style.display = "grid";
  },
};
</script>

<style scoped>
.imgscope_wrapper {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 2600px;
  -webkit-perspective: 500px;
  -moz-perspective: 500px;
  perspective: 500px;
}

.imgscope {
  background-color: #1c1e1f;
  position: absolute;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.work-img-home {
  opacity: 0.8;
  object-fit: contain;
  justify-self: flex-start;
  width: 220px;
  height: auto;
}
</style>
